import {BILLING_SERVER} from '../server';

import {athubAxios} from "../../util/athub-axios";
import {addParamsToUrl} from "../../util/common";
import {BillRestResource, getBillingAthubConfig} from "@/api/billing/billing-rest-resource";

export {BillRestResource, getBillingAthubConfig};

const customer = new BillRestResource({server: BILLING_SERVER, resource: 'customer'});
const contract = new BillRestResource({server: BILLING_SERVER, resource: 'contract'});

contract.findById = (contractId, athubConfig) => {
    return athubAxios.get(`${BILLING_SERVER}/contract/${contractId}/confirmed`, getBillingAthubConfig(athubConfig));
}

contract.modifyBusinessOpportunities = (contractId, data, athubConfig) => {
    return athubAxios.put(`${BILLING_SERVER}/contract/${contractId}/business-opportunities`, data, getBillingAthubConfig(athubConfig));
}

contract.addContractItem = (contractId, data, athubConfig) => {
    return athubAxios.post(`${BILLING_SERVER}/contract/${contractId}/item`, data, getBillingAthubConfig(athubConfig));
};

contract.getContractItemsByContractId = (contractId, athubConfig) => {
    return athubAxios.get(`${BILLING_SERVER}/contract/${contractId}/item`, getBillingAthubConfig(athubConfig));
};

contract.getConfirmedContractItemsByContractId = (contractId, athubConfig) => {
    return athubAxios.get(`${BILLING_SERVER}/contract/${contractId}/item/confirmed`, getBillingAthubConfig(athubConfig));
};

contract.getContractTaskDetailList = (data, athubConfig) => {
    return athubAxios.post(`${BILLING_SERVER}/contract-task/detail/page`, data, getBillingAthubConfig(athubConfig));
}
contract.getContractTaskDetailById = (id, athubConfig) => {
    return athubAxios.get(`${BILLING_SERVER}/contract-task/detail/${id}`, getBillingAthubConfig(athubConfig));
}
contract.updateContractTaskDetailById = (id, data, athubConfig) => {
    return athubAxios.put(`${BILLING_SERVER}/contract-task/${id}`, data, getBillingAthubConfig(athubConfig));
}

// 合同条款
contract.addContractTerm = (contractId, data, athubConfig) => {
    return athubAxios.post(`${BILLING_SERVER}/contract/${contractId}/terms`, data, getBillingAthubConfig(athubConfig));
};
contract.getContractTermsByContractId = (contractId, athubConfig) => {
    return athubAxios.get(`${BILLING_SERVER}/contract/${contractId}/terms`, getBillingAthubConfig(athubConfig));
};
contract.getConfirmedContractTermsByContractId = (contractId, athubConfig) => {
    return athubAxios.get(`${BILLING_SERVER}/contract/${contractId}/terms/confirmed`, getBillingAthubConfig(athubConfig));
};
contract.getContractTermsDetail = (contractId, contractTermId, athubConfig) => {
    return athubAxios.get(`${BILLING_SERVER}/contract/${contractId}/terms/${contractTermId}`, getBillingAthubConfig(athubConfig));
};
contract.getConfirmedContractTermsDetail = (contractId, contractTermId, athubConfig) => {
    return athubAxios.get(`${BILLING_SERVER}/contract/${contractId}/terms/${contractTermId}/confirmed`, getBillingAthubConfig(athubConfig));
};
contract.deleteContractTerm = (contractId, contractTermId, athubConfig) => {
    return athubAxios.delete(`${BILLING_SERVER}/contract/${contractId}/terms/${contractTermId}`, getBillingAthubConfig(athubConfig));
};
contract.updateContractTerm = (contractId, contractTermId, athubConfig) => {
    return athubAxios.put(`${BILLING_SERVER}/contract/${contractId}/terms/${contractTermId}`, getBillingAthubConfig(athubConfig));
};

contract.getContractItemByContractItemUuid = (contractId, contractItemUuid, athubConfig) => {
    return athubAxios.get(`${BILLING_SERVER}/contract/${contractId}/item/${contractItemUuid}`, getBillingAthubConfig(athubConfig));
};

contract.getConfirmedContractItem = (contractId, contractItemUuid, athubConfig) => {
    return athubAxios.get(`${BILLING_SERVER}/contract/${contractId}/item/${contractItemUuid}/confirmed`, getBillingAthubConfig(athubConfig));
};

contract.modifyContractItemByContractItemUuid = (contractId, contractItemUuid, data, athubConfig) => {
    return athubAxios.put(`${BILLING_SERVER}/contract/${contractId}/item/${contractItemUuid}`, data, getBillingAthubConfig(athubConfig));
};

contract.removeContractItemByContractItemUuid = (contractId, contractItemUuid, athubConfig) => {
    return athubAxios.delete(`${BILLING_SERVER}/contract/${contractId}/item/${contractItemUuid}`, getBillingAthubConfig(athubConfig));
};

contract.getContractConfigItemByContractConfigItemId = (contractConfigItemId, athubConfig) => {
    return athubAxios.get(addParamsToUrl(`${BILLING_SERVER}/contract/config/item/${contractConfigItemId}`, {
    }), getBillingAthubConfig(athubConfig));
};

contract.getContractConfigItems = (contractConfigItemIds, athubConfig) => {
    return athubAxios.get(addParamsToUrl(`${BILLING_SERVER}/contract/config/item`, {
        contractConfigItemIds: contractConfigItemIds
    }), getBillingAthubConfig(athubConfig));
};

contract.workflowAudit = (data, athubConfig) => {
    return athubAxios.postByMultipartForm(`${BILLING_SERVER}/contract/workflow/audit`, data, getBillingAthubConfig(athubConfig));
};

const contractItemRecord = new BillRestResource({server: BILLING_SERVER, resource: 'contract/item/record'});

contractItemRecord.getDetail = (id, itemId, month, content, athubConfig) => {
    return athubAxios.get(addParamsToUrl(`${BILLING_SERVER}/contract/item/record/detail`, {
        id: id,
        itemId: itemId,
        month: month,
        content: content,
    }), getBillingAthubConfig(athubConfig));
};

contractItemRecord.addDetail = (model, athubConfig) => {
    return athubAxios.post(`${BILLING_SERVER}/contract/item/record/detail`, model, getBillingAthubConfig(athubConfig));
};

contractItemRecord.modifyDetail = (id, model, athubConfig) => {
    return athubAxios.put(`${BILLING_SERVER}/contract/item/record/detail/${id}`, model, getBillingAthubConfig(athubConfig));
};

contractItemRecord.getByMonth= (beginMonth, endMonth, itemIds, athubConfig) => {
    return athubAxios.get(addParamsToUrl(`${BILLING_SERVER}/contract/item/record/month`, {
        beginMonth: beginMonth,
        endMonth: endMonth,
        itemIds: itemIds,
    }), getBillingAthubConfig(athubConfig));
};

const contractBillAdjust = new BillRestResource({server: BILLING_SERVER, resource: 'contract/bill/adjust'});

const contractBillMonth = new BillRestResource({server: BILLING_SERVER, resource: 'contract/bill/month'});

contractBillMonth.getFlowsById = (id, athubConfig) => {
    return athubAxios.get(`${BILLING_SERVER}/contract/bill/month/${id}/flow`, getBillingAthubConfig(athubConfig));
};

contractBillMonth.calculateBillDetail = (contractId, month, contractBillId, athubConfig) => {
    return athubAxios.get(addParamsToUrl(`${BILLING_SERVER}/contract/bill/month/calculate`, {
        contractId: contractId,
        month: month,
        contractBillId: contractBillId,
    }), getBillingAthubConfig(athubConfig));
};

contractBillMonth.getConfirmedContractBillMonth = (id, athubConfig) => {
    return athubAxios.get(`${BILLING_SERVER}/contract/bill/month/confirmed/${id}`, getBillingAthubConfig(athubConfig));
};

contractBillMonth.workflowAudit = (data, athubConfig) => {
    return athubAxios.postByMultipartForm(`${BILLING_SERVER}/contract/bill/month/workflow/audit`, data, getBillingAthubConfig(athubConfig));
};

contractBillMonth.calculateBillDetail = (contractId, month, contractBillId, athubConfig) => {
    return athubAxios.get(addParamsToUrl(`${BILLING_SERVER}/contract/bill/month/calculate`, {
        contractId: contractId,
        month: month,
        contractBillId: contractBillId,
    }), getBillingAthubConfig(athubConfig));
};


const receiptConfig = new BillRestResource({server: BILLING_SERVER, resource: 'receiptConfig'});

const BillingServer = {
    customer: customer,
    contract: contract,
    contractItemRecord: contractItemRecord,
    contractBillAdjust: contractBillAdjust,
    contractBillMonth: contractBillMonth,
    receiptConfig: receiptConfig,
};

export default BillingServer;

const getRegionTrees = (athubConfig) => {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${BILLING_SERVER}/region/trees`, getBillingAthubConfig(athubConfig)).then(res => {
            if (res.data.success) {
                resolve(res.data.data);
            } else {
                reject(res.data.responseMessage);
            }
        }, error => {
            reject(error);
        });
    });
};

// 生成guid
const generateGuid = (athubConfig) => {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${BILLING_SERVER}/id/create`, getBillingAthubConfig(athubConfig)).then(res => {
            if (res.data.success) {
                resolve(res.data.data);
            } else {
                reject(res.data.responseMessage);
            }
        }, error => {
            reject(error);
        });
    });
};

export {
    getRegionTrees,
    generateGuid,
};

/**
 * 查询客户账单分页列表
 * @param params
 * @returns {Promise<unknown>}
 */
export function selectCustomerBillPage(params){
    return new Promise((resolve,reject) => {
        athubAxios.post(BILLING_SERVER+"/customer/bill/page",params, getBillingAthubConfig())
            .then(result => {
                if (result.status===200){
                    resolve(result);
                }else{
                    result.data.success ? resolve(result.data.data) : reject(result.data.responseMessage);
                }
            }, (error)=> {
                reject(error);
            });
    });
}

/**
 * 合同账单类型下拉框
 */
export function selectCustomerBillTypeOptions(){
    return new Promise((resolve, reject) => {
        athubAxios.get(`${BILLING_SERVER}/customer/bill/contract/options`,getBillingAthubConfig())
            .then(result => {
                if (result.status===200){
                    resolve(result);
                }else{
                    result.data.success ? resolve(result.data.data) : reject(result.data.responseMessage);
                }
            },(error)=>{
                reject(error);
            });
    })
}

/**
 * 账单状态下拉框
 */
export function selectCustomerBillStatusOptions(type){
    return new Promise((resolve, reject) => {
        athubAxios.get(`${BILLING_SERVER}/customer/bill/options/${type}`,getBillingAthubConfig())
            .then(result => {
                if (result.status===200){
                    resolve(result);
                }else{
                    result.data.success ? resolve(result.data.data) : reject(result.data.responseMessage);
                }
            },(error)=>{
                reject(error);
            });
    })
}

/**
 * 删除账单
 */
export function deleteCustomerBillById(id){
    return new Promise((resolve, reject) => {
        athubAxios.delete(`${BILLING_SERVER}/customer/bill/${id}`,getBillingAthubConfig())
            .then(result => {
                if (result.status===200){
                    resolve(result);
                }else{
                    result.data.success ? resolve(result.data.data) : reject(result.data.responseMessage);
                }
            },(error)=>{
                reject(error);
            });
    })
}

//分页显示客户计费月报
export function selectCustomerBillMonthPage(params){
    return new Promise((resolve, reject) => {
        athubAxios.post(`${BILLING_SERVER}/customer/bill/contract/page`,params,getBillingAthubConfig())
            .then(result => {
                if (result.status===200) {
                    resolve(result);
                }else{
                    result.data.success ?resolve(result):reject(result.data.responseMessage);
                }
            },(error) => {
                reject(error);
            });
    })
}

/**
 * 根据账单ID查询账单详情
 */
export function selectBillDetailByBillId(id){
    return new Promise((resolve, reject) => {
        athubAxios.get(`${BILLING_SERVER}/customer/bill/${id}`,getBillingAthubConfig())
            .then(result => {
                if (result.status===200) {
                    resolve(result);
                }else{
                    result.data.success ?resolve(result):reject(result.data.responseMessage);
                }
            },(error) => {
                reject(error);
            });
    })
}

/**
 * 根据账单ID查询最新的his信息
 * @param id
 * @returns {Promise<unknown>}
 */
export function selectBillDetailNewHisByBillId(id){
    return new Promise((resolve, reject) => {
        athubAxios.get(`${BILLING_SERVER}/customer/bill/${id}/new`,getBillingAthubConfig())
            .then(result => {
                if (result.status===200) {
                    resolve(result);
                }else{
                    result.data.success ?resolve(result):reject(result.data.responseMessage);
                }
            },(error) => {
                reject(error);
            });
    })
}

/**
 * 流程变更:下一流程
 */
export function nextFlow(params){
    return new Promise((resolve, reject) => {
        athubAxios.post(`${BILLING_SERVER}/customer/bill/flow`,params,getBillingAthubConfig())
            .then(result => {
                if (result.status===200){
                    resolve(result);
                }else{
                    result.data.success ?resolve(result):reject(result.data.responseMessage);
                }
            },(error) => {
                reject(error);
            });
    })
}

/**
 * 生成id
 */
export function nextId(){
    return new Promise((resolve, reject) => {
        athubAxios.get(`${BILLING_SERVER}/id/create`,getBillingAthubConfig())
            .then(result => {
                if (result.status===200){
                    resolve(result);
                }else{
                    reject('生成失败,请重试');
                }
            },(error) => {
                reject(error);
            })
    })
}

/**
 * 生成账单
 */
export function generatorContractBill(params){
    return new Promise((resolve, reject) => {
        athubAxios.post(BILLING_SERVER+"/customer/bill/",params,getBillingAthubConfig())
            .then(result =>{
                    if (result.status===200){
                        resolve(result);
                    }else{
                        reject('生成账单失败,请重试');
                    }
                },(error =>{
                    reject(error);
                })
            )
    })
}

export function exportPDFByBillId(billId){
    athubAxios.download(`${BILLING_SERVER}/customer/bill/export/pdf/`+billId,'客户账单.pdf',getBillingAthubConfig());
}

export function downloadFile(flowId,index){
    athubAxios.download(`${BILLING_SERVER}/customer/bill/download/`+flowId+"/"+index,'附件',getBillingAthubConfig());
}

export function getResourceBillingStatusChangeWOInfoNoPage(query, athubConfig) {
    let url = `${BILLING_SERVER}/resource/resourceBillingStatusChangeWO/info/noPage`;
    return new Promise((resolve, reject) => {
        athubAxios.get(addParamsToUrl(url, {
            queryString: JSON.stringify(query)
        }), getBillingAthubConfig(athubConfig, ["billing.be.RBSC.WO.viewAll"])).then(response => {
            if (response.status === 200) {
                resolve(response.data.data);
            } else {
                reject(response.data.responseMessage);
            }
        }).catch((error) => {
            reject(error);
        });
    });
}
